<template>
  <div class="content-box">
    <fieldset>
      <v-row>
        <v-col cols="6">
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.cpu.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.cputi | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.rfc.cpic.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rfcti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.tot.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="(mainrec.rollinti + mainrec.procti + mainrec.generateti + mainrec.reploadti + mainrec.dynploadti + mainrec.cualoadti + mainrec.dbreqtime + mainrec.dbpreqtime + mainrec.lockti) | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <fieldset>
                <!-- eslint-disable-next-line prettier/prettier -->
                <legend><span>{{ $t('ssr.title.rt') }}</span></legend>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.rt') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="mainrec.respti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.wait.wp') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="mainrec.queueti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.proc.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="mainrec.procti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.load.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="(mainrec.reploadti + mainrec.dynploadti + mainrec.cualoadti) | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.gen.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="mainrec.generateti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.roll.all.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="(mainrec.rollinti + mainrec.rolledOut) | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.db.req.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="(mainrec.dbreqtime + mainrec.dbpreqtime) | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
                <v-row>
                  <!-- eslint-disable-next-line prettier/prettier -->
                  <v-col cols="7"><p class="label">{{ $t('ssr.title.enq.time') }}</p></v-col>
                  <v-col cols="5"><v-text-field :value="mainrec.lockti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
                </v-row>
              </fieldset>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="4"><p class="label">{{ $t('ssr.title.number') }}</p></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="3"><p class="label">{{ $t('ssr.title.roll.in') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rollincnt | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.roll.out') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rolloutcnt | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.enq') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.lockcnt | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="4"><p class="label">{{ $t('ssr.title.load.time') }}</p></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="3"><p class="label">{{ $t('ssr.title.prog') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.reploadti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.screen') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.dynploadti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.cua.interf') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.cualoadti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="4"><p class="label">{{ $t('ssr.title.roll.time') }}</p></v-col>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="3"><p class="label">{{ $t('ssr.title.out') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rolloutti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.in') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rollinti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.wait') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.rolledOut | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.fe.round') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.guicnt | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.gui.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.guitime | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.net.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="mainrec.guinettime | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
        </v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { merge } from 'lodash';
import tabable from './tabable';

export default {
  mixins: [tabable],
  computed: {
    ...mapState('analysis/ssr', ['mainrec']),
  },
  methods: {
    ...mapActions('analysis/ssr', ['fetchMainrec']),
    async fetch(params) {
      await this.fetchMainrec(
        merge({}, params, {
          account: this.step.account,
          terminalid: this.step.terminalid,
        }),
      );
      this.increaseLoadingCount();
    },
  },
};
</script>
<style lang="scss" scoped>
@import './tab';
</style>
